import State from "ducks/state"
import {connect} from "react-redux"

export const mapStateToProps = (state: State) => {
    const {
        template: {mainTemplate, fallbackTemplate},
    } = state

    return {
        mainTemplate,
        fallbackTemplate,
    }
}

export default connect(mapStateToProps)
